import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { getCookie } from 'common/cookies';
import EnvConfig from 'env.config';
import LocalisedMessage from 'components/Common/LocalisedMessage';
import MustHaveReadText from 'components/MustHaveReadText';

import ModalWrapper from 'components/Modals/ModalWrapper';

import { acceptEula } from 'actions';

const contains = (intl, messageId) => intl && intl.messages && !!intl.messages[messageId] && intl.messages[messageId] !== 'End-User License Agreement';

const { eulaCookieName } = EnvConfig;

const Eula = ({ dispatch, intl, fullDictionaryLoaded, onConfirm, onCancel }) => {
  const [allRead, setAllRead] = useState(false);

  const eulaAccepted = !!getCookie(eulaCookieName);
  const isEulaEnabled = contains(intl, 'eula');
  const content = <div><LocalisedMessage id="eula" /></div>;

  useEffect(() => {
    if (fullDictionaryLoaded && !isEulaEnabled) {
      dispatch(acceptEula());
    }
  }, []);

  const onCancelClick = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const onConfirmClick = () => {
    dispatch(acceptEula(true));

    if (onConfirm) {
      onConfirm();
    }
  };

  return (<React.Fragment>
    { (!eulaAccepted && isEulaEnabled && content) && <ModalWrapper
      title={ <h1><LocalisedMessage id="eula.title" /></h1> }
      className="modal-eula"
      disableConfirm={ !allRead }
      showCancel={ false }
      showClose={ false }
      btnConfirmTitle={ intl.formatMessage({ id: 'eula.agreementButton' }) }
      content={ <MustHaveReadText
        content={ content }
        IsTextRead={ value => setAllRead(value) }
      /> }
      footer={ !allRead ? <LocalisedMessage id="eula.agreementNotRead" /> : <LocalisedMessage id="eula.agreementRead" /> }
      onConfirm={ onConfirmClick }
      onCancel={ onCancelClick }
    />}
  </React.Fragment>);
};

Eula.propTypes = {
  dispatch: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  fullDictionaryLoaded: PropTypes.bool
};

Eula.defaultProps = {
  onConfirm: null,
  onCancel: null,
  fullDictionaryLoaded: false
};

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    app: {
      fullDictionaryLoaded
    }
  } = state;

  return {
    fullDictionaryLoaded
  };
}

export default injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps
)(Eula));
